import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import AutoFocus from '../AutoFocus'
import { Modal } from 'react-bootstrap'
import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'

import Clickable from '../../components/Clickable'

import base from 'Styles/base.css'
import style from './tipsForSuccessModal.css'

import closeIcon from 'Assets/x-icon-gray.svg'

export default function TipsForSuccessModal (props) {
  return (
    <div>
      <Modal show={true} className={classnames(style.modalContainer)}>
        <Modal.Body className={style.container}>
          <div>
            <Row>
              <Col xs={10}>
                <AutoFocus>
                  <h2 className={style.tipsModalHeader}>
                    Tips for Success
                  </h2>
                </AutoFocus>
              </Col>
              <Col xs={2}>
                <button
                  data-test-id="hideTipsBtn"
                  aria-label="Close Tips for Success"
                  className={classnames(style.hideTips)}
                  onClick={props.onCancel}
                  tabIndex="0"
                >
                  <object
                    data={closeIcon} type="image/svg+xml"
                    className={base.svgIcon}
                    tabIndex="-1"
                  />
                </button>
              </Col>
            </Row>
            <ul data-test-id="tipsForSuccessList" className={style.tipsList}>
              <li>Score points by answering questions.</li>
              <li>Once you reach the target score you will receive a grade of 100%.</li>
              <li>Earn maximum points for questions you answer on the first try.</li>
              <li>Check the ebook before you answer, it doesn't cost you any points.</li>
              <li>Hints are available, but you earn fewer points when you use them.</li>
              <li>You can skip a question by showing the answer, but you won't earn points.</li>
              <li>Questions get harder and are worth more points as you progress.</li>
              <li>If you want additional practice,
                you can keep answering questions after the target score is reached.</li>
            </ul>

            <p className={style.faqText}>
              <span aria-hidden="true">For more information, </span>
              <Clickable
                data-test-id="faqLink"
                aria-label="For more information, see our FAQ."
                className={style.faqLink}
                onClick={props.faqClick}
                tabIndex="0"
              >
                see our FAQ.
              </Clickable>
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className={classnames('modal-footer', style.footerContainer)} />
      </Modal>
    </div>
  )
}

TipsForSuccessModal.propTypes = {
  faqClick: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}
